import {TagObject} from './tag-model';

export class VideoObject {
    public id: number;
    public secret: string;
    public type: 'video' | 'audio';
    public name: string;
    public unmuteLabel: string;
    public showUnmute: boolean;
    public countdownTheme: string;
    public poster: string;
    public posterFit: string;

    public posterPause: string;
    public posterPauseFit: 'fit' | 'contain' | 'cover';
    public posterEnd: string;
    public posterEndFit: 'fit' | 'contain' | 'cover';
    public bgColor: string;
    public primaryColor: string;
    public secondaryColor: string;
    //public alterControls: boolean;
    public enablePlayButton: boolean;
    public enableBack10: boolean;
    public enableForward10: boolean;
    public enableVolume: boolean;
    public enableTime: boolean;
    public enableFullscreen: boolean;
    public enableProgressbar: boolean;
    public enableLogo: boolean;
    public progressbarHeight: number;

    public showLabel: boolean;
    public path: string;
    public domainProtection = [];
    public hasWebm: boolean;

    public floatingEnabled: boolean;
    public floatingColor: string;
    public floatingRange: number;

    public tags: TagObject[] = [];

    public officeUserId: number;

    constructor(obj: any) {
        this.id = +obj.id;
        this.secret = obj.secret;
        this.type = obj.type;
        this.name = obj.name;
        this.unmuteLabel = obj.unmute_label;
        this.showUnmute = obj.show_unmute === '1';
        this.countdownTheme = obj.countdown_theme;
        this.poster = obj.poster;
        this.posterFit = obj.poster_fit;

        this.posterPause = obj.poster_pause;
        this.posterPauseFit = obj.poster_pause_fit;
        this.posterEnd = obj.poster_end;
        this.posterEndFit = obj.poster_end_fit;
        this.bgColor = obj.bg_color;

        this.primaryColor = obj.primary_color;
        this.secondaryColor = obj.secondary_color;
        //this.alterControls = obj.alter_controls === '1';
        this.enablePlayButton = obj.enable_play_button === '1';
        this.enableBack10 = obj.enable_back10 === '1';
        this.enableForward10 = obj.enable_forward10 === '1';
        this.enableVolume = obj.enable_volume === '1';
        this.enableTime = obj.enable_time === '1';
        this.enableFullscreen = obj.enable_fullscreen === '1';
        this.enableProgressbar = obj.enable_progressbar === '1';
        this.enableLogo = obj.enable_logo === '1';
        this.progressbarHeight = +obj.progressbar_height;

        this.showLabel = obj.show_label === '1';
        this.path = obj.path;
        try {
            this.domainProtection = JSON.parse(obj.domain_protection);
        } catch (e) {

        }

        this.floatingEnabled = obj.floating_enabled === '1';
        this.floatingColor = obj.floating_color;
        this.floatingRange = +obj.floating_range;

        if (obj.hasOwnProperty('tags')) {
            for (const tag of obj.tags) {
                this.tags.push(new TagObject(tag));
            }
        }
        this.hasWebm = obj.has_webm === '1';

        this.officeUserId = obj.office_user_id;
    }

    public getImageTags(): TagObject[] {
        return this.tags.filter(value => {
            if (value.viewType === 'image') {
                return true;
            }
            return false;
        });
    }

    public getSnackbarTags(): TagObject[] {
        return this.tags.filter(value => {
            if (value.viewType === 'snackbar') {
                return true;
            }
            return false;
        });
    }


}
